
export const resizeBase64Image = (base64, width, height) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);
            canvas.toBlob((blob) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            }, "image/webp");
        };
        img.onerror = reject;
        img.src = base64;
    });
};

export const MAX_IMAGE_WIDTH = 640;
export const MAX_IMAGE_HEIGHT = 480;
export const MAX_IMAGE_AREA = MAX_IMAGE_WIDTH * MAX_IMAGE_HEIGHT;

export const checkImageSizeAndShrinkIfNeeded = async (base64, width, height) => {
    const imageArea = width * height;
    if (imageArea > MAX_IMAGE_AREA) {
        const scale = Math.sqrt(MAX_IMAGE_AREA / imageArea);
        const newWidth = Math.round(width * scale);
        const newHeight = Math.round(height * scale);
        return resizeBase64Image(base64, newWidth, newHeight);
    }
    return base64;
};


export const getBase64Size = (base64) => {
    const base64String = base64.split(',')[1]; // remove `data:image/...;base64,`
    const sizeInBytes = (base64String.length * 3) / 4;
    const sizeInMB = sizeInBytes / (1024 * 1024);
    return { sizeInBytes, sizeInMB };
};